import {createContext, useMemo} from 'react';
import {Visibility, Widget, WidgetAPI} from './api';
import {createParentMessageBus, isIframed, ParentMessageBus} from './iframe';

export const WidgetContext = createContext<Widget>(new Widget());

export const WidgetProvider = ({
  initialVisibility,
  audience,
  entryPoint,
  parentOrigin,
  actionHandler,
  parentMessageBus,
  children,
}: {
  initialVisibility?: Visibility;
  parentOrigin?: string;
  audience?: string;
  entryPoint?: string;
  actionHandler?: WidgetAPI['requestAction'];
  parentMessageBus?: ParentMessageBus;
  children: React.ReactNode;
}) => {
  const parentBus = useMemo(() => {
    if (parentMessageBus) {
      return parentMessageBus;
    }

    if (isIframed() && parentOrigin) {
      return createParentMessageBus({audience, entryPoint, parentOrigin});
    }

    return undefined;
  }, [audience, entryPoint, parentOrigin, parentMessageBus]);

  const widget = useMemo(() => {
    const memo = new Widget({initialVisibility, parentBus, actionHandler});
    return memo;
  }, [initialVisibility, parentBus, actionHandler]);

  return (
    <WidgetContext.Provider value={widget}>{children}</WidgetContext.Provider>
  );
};
